<template>
  <div>

    <template style="height: 100vh;">
      <v-col cols="12" class=" fill-height d-flex flex-column justify-center align-center pa-0">

        <v-card width="600" elevation="0" tile>

          <v-card-text class="mt-3">
            <p class="text-h3 text-center">Let's get started</p>
          </v-card-text>

          <v-stepper v-model="stp" alt-labels elevation="0">

            <v-stepper-header elevation="0" class="text-caption">
              <v-stepper-step :complete="stp > 1" step="1">
                Business Info
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="stp > 2" step="2">
                Terminologies
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="stp > 3" step="3">
                Miscellaneous
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="stp > 4" step="4">
                Import
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items outlined>
              <v-stepper-content step="1" class="px-0">
                <v-card class="pa-6" elevation="0" outlined>

                  <v-card-text class="">
                    <p class="text-subtitle-1 ma-0 text-center black--text">Setup your Nex Scheduler
                      account</p>
                    <p class="text-caption ma-0 text-center text-light">
                      Update your company or organization name and timezone.
                    </p>
                  </v-card-text>

                  <v-card-text class="">

                    <account-edit-form :account.sync="account" @continueNext="continueNext()"></account-edit-form>

                  </v-card-text>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2" class="px-0">

                <terminology-table :account.sync="account" @continueNext="continueNext()"
                  :isBlockButton="true"></terminology-table>

              </v-stepper-content>


              <v-stepper-content step="3" class="px-0">
                <v-card class="pa-6" elevation="0" outlined>
                  <v-card-text class="">
                    <p class="text-subtitle-1 ma-0 text-center black--text">Add and define some details for your account
                    </p>
                    <p class="text-caption ma-0 text-center text-light">
                      To work seamlessly please add or define
                      data needed to start using
                      with Nex Scheduler.
                    </p>

                  </v-card-text>
                  <v-card-text>

                    <p class="text-overline ma-0">
                      {{ this.termProgram }}
                    </p>
                    <p class="text-caption">Add Programs or Services that you can offer to you client, customers or
                      students</p>
                    <v-btn class="ma-2" small plain color="indigo" @click="programDialog = true">
                      <v-icon>mdi-plus</v-icon>
                      Add
                    </v-btn>

                    <v-template v-for="prgrm in programList" :key="prgrm.id">
                      <v-chip outlined class="ma-2" color="primary" @click="editProgram(prgrm)">
                        <v-icon small class="mr-2">mdi-pencil</v-icon> {{ prgrm.name }}
                      </v-chip>
                    </v-template>

                  </v-card-text>
                  <v-divider></v-divider>

                  <v-card-text>
                    <p class="text-overline ma-0">
                      {{ this.termClassroom }}
                    </p>
                    <p class="text-caption">Term for place or room where transaction, service, program, activity or
                      learning happen</p>


                    <v-btn class="ma-2" small plain color="indigo" @click="classroomDialog = true">
                      <v-icon>mdi-plus</v-icon>
                      Add
                    </v-btn>

                    <v-template v-for="clssrm in classroomList" :key="clssrm.id">
                      <v-chip outlined class="ma-2" color="primary" @click="editClassroom(clssrm)">
                        <v-icon small class="mr-2">mdi-pencil</v-icon> {{ clssrm.roomNumber }}
                      </v-chip>
                    </v-template>

                  </v-card-text>
                </v-card>
              </v-stepper-content>


              <v-stepper-content step="4" class="px-0">

                <v-card class="pa-6" elevation="0" outlined>

                  <v-card-text class="">
                    <p class="text-subtitle-1 ma-0 text-center black--text">Import your initial data to kick-start your
                      experience
                    </p>
                    <p class="text-caption ma-0 text-center text-light">
                      Importing your data is crucial for
                      a smooth transition and accurate usage of
                      Nex Scheduler.
                    </p>
                  </v-card-text>
                  <v-card-text>

                    <v-tabs v-model="tabs" fixed-tabs centered icons-and-text>
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab href="#mobile-tabs-5-1" class="primary--text">

                        {{ this.termTeacher }}

                        <v-icon>mdi-account-tie</v-icon>
                      </v-tab>

                      <v-tab href="#mobile-tabs-5-2" class="primary--text">

                        {{ this.termStudent }}

                        <v-icon>mdi-account-group</v-icon>
                      </v-tab>

                    </v-tabs>

                    <v-tabs-items v-model="tabs">
                      <v-tab-item value="mobile-tabs-5-1">

                        <import-teachers :termlabel="termTeacher"></import-teachers>

                      </v-tab-item>

                      <v-tab-item value="mobile-tabs-5-2">
                        <import-students :termlabel="termStudent"></import-students>
                      </v-tab-item>
                    </v-tabs-items>

                  </v-card-text>

                </v-card>

              </v-stepper-content>

            </v-stepper-items>

          </v-stepper>

          <v-card elevation="0 pb-5">

            <v-sheet class="d-md-flex">
              <v-sheet class="flex-sm-column"></v-sheet>
              <v-spacer></v-spacer>
              <v-sheet class="justify-right text-end">

                <v-btn v-if="stp != 1" small fab icon color="primary" @click="prevStep()">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>

                <v-btn v-if="stp != 4" outlined rounded class="ml-4" color="primary" @click="nextStep()">
                  Skip
                </v-btn>

                <v-btn v-if="stp == 4" outlined rounded x-large color="primary" @click="closeOnboardingForm">
                  Finish
                </v-btn>
              </v-sheet>

            </v-sheet>

          </v-card>

        </v-card>

      </v-col>
    </template>

    <v-row justify="center">
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

        <v-card elevation="0">
          <v-toolbar color="transparent" elevation="0">
            <v-btn icon color="grey" @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-subtitle-2 grey--text">
              Setup your account
            </v-toolbar-title>

          </v-toolbar>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="terminologyDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Terminology</span>
          </v-card-title>
          <v-card-text>
            <terminology-form :isModal="true" @clicked="closeTerminologyDialog"></terminology-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="programDialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <program-form :key="programId" :id="programId" :isModal="true" @clicked="closeProgramDialog"></program-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="classroomDialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <classroom-form :key="classroomId" :id="classroomId" :isModal="true"
              @clicked="closeClassroomDialog"></classroom-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>


  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { rules } from '@/store/util/rules.js';
import { parseDomain } from "parse-domain";

const accountEditForm = () => import("@/components/account/editBasic.vue");
const TerminologyForm = () => import("@/components/accountTerminology/AccountTerminologyForm.vue");
const ProgramForm = () => import("@/components/program/ProgramForm.vue");
const ClassroomForm = () => import("@/components/classroom/ClassroomForm.vue");

const ImportTeachers = () => import("@/components/common/ImportTeachers.vue");
const ImportStudents = () => import("@/components/common/ImportStudents.vue");
const TerminologyTable = () => import("@/components/account/terminologyTableForm.vue");

export default {
  name: 'onboarding',
  props: ["accountId"],
  components: {
    accountEditForm,
    TerminologyForm,
    ProgramForm,
    ClassroomForm,
    ImportTeachers,
    ImportStudents,
    TerminologyTable
  },
  data() {
    return {
      stp: 1,
      account: [],
      rules,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100
      },
      programList: [],
      classroomList: [],
      terminologyDialog: false,
      programDialog: false,
      classroomDialog: false,
      tabs: null,
      programId: null,
      classroomId: null,
      terminologyObject: [],
      termProgram: "Program",
      termClassroom: "Classroom",
      termTeacher: "Teacher",
      termStudent: "Student",
    };
  },
  computed: {
    ...mapGetters("terminology", ["terminologies"]),
  },
  created() {
    this.getResources();
  },
  mounted() {
    this.initAccount().then((account) => {
      this.account = account;
      if (!this.account.timezone) {
        this.account.timezone = 'America/New_York'; //Default
      }
    })
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    ...mapActions("classroom", ["fetchClassrooms"]),
    ...mapActions("program", ["fetchPrograms"]),
    ...mapActions("accountTerminology", ["fetchAccountTerminologies"]),
    addTerminology() {
      this.terminologyDialog = true;
    },
    getResources() {
      this.getClassrooms();
      this.getPrograms();
    },
    getPrograms() {
      const params = {
        page: this.pagination.pageIndex && this.pagination.pageIndex > 0 ? this.pagination.pageIndex - 1 : 0,
      };
      this.fetchPrograms(params)
        .then(response => {
          if (response) {
            this.programList = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    getClassrooms() {
      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
      };
      this.fetchClassrooms(params)
        .then((response) => {
          if (response) {
            this.classroomList = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    closeTerminologyDialog() {
      this.terminologyDialog = false;
      this.getTerminologies();
    },
    closeClassroomDialog() {
      this.classroomDialog = false;
      this.classroomId = null;
      this.getClassrooms();
    },
    closeProgramDialog() {
      this.programDialog = false;
      this.programId = null;
      this.getPrograms();
    },
    prevStep() {
      if (this.stp == 1) {
        return;
      }
      this.stp--;
    },
    nextStep() {
      this.getUpdatedTerminologies();

      if (this.stp == 4) {
        return;
      }
      this.stp++;
    },
    async initAccount() {
      return await this.$axios
        .get("/account/get-by-id", {
          params: { accountId: this.accountId },
        })
        .then((resp) => {
          return resp.data;

        })
        .catch(() => {
          this.addErrorMessage("Error loading account from server");
        });
    },
    continueNext() {
      this.getUpdatedTerminologies();
      this.nextStep();
    },
    closeOnboardingForm() {
      if (process.env.NODE_ENV != 'development') {
        const parseResult = parseDomain(window.location.hostname);
        const { domain, topLevelDomains } = parseResult;
        const topLevel = topLevelDomains.join(".");
        const scheduler = 'scheduler';

        const moduleUrl = `https://${scheduler}.${domain}.${topLevel}`;
        window.location.href = moduleUrl;
      }
    },
    addClassroom() {
      this.classroomId = 0;
      this.classroomDialog = true;
    },
    editClassroom(item) {
      this.classroomId = item.id;
      this.classroomDialog = true;
    },
    addProgram() {
      this.programIdId = 0;
      this.programDialogDialog = true;
    },
    editProgram(item) {
      this.programId = item.id;
      this.programDialog = true;
    },
    getUpdatedTerminologies() {
      this.fetchAccountTerminologies()
        .then(response => {
          if (response) {
            this.terminologyObject = response.content;
            this.termProgram = this.terminologyObject.filter(item => item.name.toLowerCase() == 'program')[0].value;
            this.termClassroom = this.terminologyObject.filter(item => item.name.toLowerCase() == 'classroom')[0].value;
            this.termTeacher = this.terminologyObject.filter(item => item.name.toLowerCase() == 'teacher')[0].value;
            this.termStudent = this.terminologyObject.filter(item => item.name.toLowerCase() == 'student')[0].value;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
  },
};
</script>
<style scoped>
.v-stepper__header {
  box-shadow: none;
}
</style>
